export enum AuthTypes {
  LOGOUT_ADMIN = 'LOGOUT_ADMIN',
  SIGNIN_ADMIN_SUCCESS = 'SIGNIN_ADMIN_SUCCESS',
  SIGNIN_ADMIN = 'SIGNIN_ADMIN',
  SIGNIN_ANONYMOUS = 'SIGNIN_ANONYMOUS',
}
